import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Slide({ combine, cart, setCart, setShowMessage }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [add, setAdd] = useState(false);
  return (
    <div className="slide">
      <div className="image">
        {combine?.images[0]?.url ? (
          <img src={combine?.images[0].url} alt={combine?.name} />
        ) : (
          <div
            style={{
              background: "#575656",
              width: "100%",
              height: "100%",
              borderRadius: "6px",
            }}
          ></div>
        )}
      </div>
      <div className="title" onClick={() => navigate(`/menu/${combine.id}`)}>
        <p>{combine.name}</p>
      </div>
      <div className="price">
        <div className="price-amount">
          <p>{combine.price}€</p>
        </div>
        <div className={!add ? "add" : "remove"}>
          <button
            onClick={() => {
              setAdd(!add);
              if (!add) {
                setShowMessage(true);
                setCart([
                  ...cart,
                  { ...combine, singlePrice: combine.price, amount: 1 },
                ]);
              } else {
                setCart(
                  cart.filter((item) => {
                    if (item.id !== combine.id) {
                      return true;
                    } else {
                      return false;
                    }
                  }),
                );
              }
            }}
          >
            {!add ? `${t("add")}` : "Премахни"}
          </button>
        </div>
      </div>
    </div>
  );
}
